<template>
  <div v-html="text" />
</template>

<script>
export default {
  name: 'Label',

  props: {
    text: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  position: relative;
  font-size: rem(16px);
  color: $color-text;
}
</style>
